import React, { useEffect, useState, useRef } from "react"
import TeaVerticalNav from "@/components/TeaVerticalNav"
import {
  Section1,
  Section2,
  Section3,
  Section4,
  SectionWrapper,
} from "./components"

type ActiveKey = "green" | "black" | "section4"

const HomePage: React.FC = (): JSX.Element => {
  const [active, setActive] = useState<ActiveKey>("green")
  const [navMode, setNavMode] = useState(false) // true khi đang ở cụm trà
  const scrollThrottleRef = useRef(false)

  // ===== preload images =====
  useEffect(() => {
    const images = [
      "/home-bg.png",
      "/Artboard-layout.png",
      "/banners/banner1.png",
      "/banners/banner2.png",
      "/banners/banner3.png",
      "/banners/banner4.png",
      "/banners/banner5.png",
      "/banners/banner6.png",
      "/banners/banner7.png",
      "/logos/leaf-icon.png",
      "/logos/leaf-white-icon.png",
      "/logos/leaf-default.png",
      "/logos/logo.png",
      "/logos/cup-of-tea.png",
      "/wood-circle.png",
      "/rope.png",
      "/flower-ring.png",
    ]
    images.forEach(src => {
      const img = new Image()
      img.src = src
    })
  }, [])

  // ===== reset scroll =====
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      ;(window.history as any).scrollRestoration = "manual"
    }
    window.scrollTo(0, 0)
  }, [])

  // ===== scroll logic =====
  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      const hero = document.querySelector('[data-section="section1"]') as HTMLElement | null
      const teaSection = document.getElementById("tea-section")
      if (!hero || !teaSection) return

      const heroBottom = hero.offsetTop + hero.offsetHeight
      const y = window.scrollY

      // === bước 1: kích hoạt navMode khi chạm mép tea-section ===
      if (!navMode && y + window.innerHeight >= heroBottom - 5 && e.deltaY > 0) {
        e.preventDefault()
        window.scrollTo({ top: teaSection.offsetTop, behavior: "smooth" })
        setNavMode(true)
        return
      }

      // === bước 2: nếu đang ở navMode → xử lý cuộn ảo ===
      if (navMode) {
        e.preventDefault()

        if (scrollThrottleRef.current) return
        scrollThrottleRef.current = true
        setTimeout(() => (scrollThrottleRef.current = false), 700)

        const sections: ActiveKey[] = ["green", "black", "section4"]
        const idx = sections.indexOf(active)

        if (e.deltaY > 0) {
          // cuộn xuống
          if (idx < sections.length - 1) {
            setActive(sections[idx + 1])
          }
        } else if (e.deltaY < 0) {
          // cuộn lên
          if (idx > 0) {
            setActive(sections[idx - 1])
          } else {
            // ở đầu cụm → thoát navMode và quay lại hero
            setNavMode(false)
            window.scrollTo({ top: hero.offsetTop, behavior: "smooth" })
          }
        }
      }
    }

    window.addEventListener("wheel", handleWheel, { passive: false })
    return () => window.removeEventListener("wheel", handleWheel)
  }, [active, navMode])

  return (
    <>
      {/* ===== Section 1 (Hero) ===== */}
      <div data-section="section1">
        <Section1 />
      </div>

      {/* ===== Section 2-3-4 (tea-section) ===== */}
      <div
        id="tea-section"
        className="w-screen h-screen bg-center bg-cover bg-no-repeat relative overflow-hidden"
        style={{
          backgroundImage: "url('/Artboard-layout.png')",
          overscrollBehavior: "contain",
        }}
      >
        <TeaVerticalNav active={active} onChange={setActive} />

        {/* các section chồng lên nhau (absolute) */}
        <div className="relative z-20 w-full h-full flex justify-center">
          <SectionWrapper visible={active === "green"}>
            <Section2 />
          </SectionWrapper>

          <SectionWrapper visible={active === "black"}>
            <Section3 />
          </SectionWrapper>

          <SectionWrapper visible={active === "section4"}>
            <Section4 />
          </SectionWrapper>
        </div>
      </div>
    </>
  )
}

export default HomePage
